import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from "material-ui/Typography";
import ArrowRight from "../Icons/ArrowRight";

const styles = () => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
  },

  guide: {
    boxShadow: '0px 0px 10px #00000026',
    borderRadius: '5px',
    padding: '55px 40px',
    marginBottom: '60px',
  },

  section: {
    // ヘッダを固定しているためアンカーリンクがずれてしまうため
    // marginTopでヘッダ要素分マイナスにする
    marginTop: '-135px',
    paddingTop: '190px'
  },

  pointLine: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderBottom: '2px solid #DBDFE1',
    paddingBottom: '15px',
    marginBottom: '25px',
    position: 'relative',

    '&:before': {
      content: '""',
      display: 'block',
      width: '60px',
      borderBottom: '2px solid #195AFF',
      position: 'absolute',
      bottom: '-2px',
      left: 0,
    },
  },

  about: {
    fontWeight: 'bold',
    fontSize: 17,
    letterSpacing: '0.34px',
    textIndent: '0.34px',
  },

  detail: {
    fontSize: 15,
    letterSpacing: '0.3px',
    textIndent: '0.3px',
    whiteSpace: 'break-spaces',
  },

  linkGroup: {
    display: 'flex',
    fontSize: 15,
    marginTop: '25px',
    justifyContent: 'space-between',
  },

  templateLink: {
    border: '1px solid #195AFF',
    borderRadius: '3px',
    width: '360px',
    textAlign: 'center',
    padding: '15px 0',
    letterSpacing: '0.3px',
    textIndent: '0.3px',
    '&:hover': {
      boxShadow: '0px 0px 15px #00000026',
      border: '1px solid #195AFF',
    }
  },

  caution: {
    margin: '25px 0 10px 0',
    padding: '15px',
    color: '#181819',
    background: '#F4F5F6',
    borderRadius: '3px',
    fontSize: 15,
    letterSpacing: '0.3px',
    textIndent: '0.3px',
  },

  bold: {
    fontWeight: 'bold',
  },

  underline: {
    textDecoration: 'underline',
  },

  articleLink: {
    padding: '25px',
    border: '1px solid #195AFF',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 0px 15px #0000001A',
      border: '1px solid #195AFF',
    }
  },

  linkText: {
    width: '620px',
  },

  link: {
    color: '#195AFF',
    letterSpacing: '0.3px',
    textIndent: '0.3px',
    textDecoration: 'underline',
  },
});

class HowToLetterSend extends React.Component {
  renderHead = (subheading, body) => {
    return (
      <React.Fragment>
        <Typography variant="subheading" style={{ fontSize: 28, marginBottom: 15, letterSpacing: '0.48px', textIndent: '0.48px', lineHeight: '1.5em' }}>
          {subheading}
        </Typography>
        <Typography variant="subheading" style={{ letterSpacing: '0.26px', textIndent: '0.26px', lineHeight: '1.5em' }}>
          {body}
        </Typography>
      </React.Fragment>
    )
  }

  renderSectionContent = (about, detail, id) => {
    const { classes } = this.props;
    return (
      <div className={classes.section} id={id}>
        <div className={classes.pointLine}>
          <div className={classes.about}>
            {about}
          </div>
        </div>
        <div className={classes.detail}>
          {detail}
        </div>
      </div>
    )
  }

  renderArticleLink = (about, detail, link) => {
    const { classes } = this.props;
    return (
      <div className={classes.articleLink} onClick={() => this.props.goTo(link)}>
        <div className={classes.linkText}>
          <div className={classes.about} style={{ fontSize: 15 }}>
            {about}
          </div>
          <div className={classes.detail}>
            {detail}
          </div>
        </div>
        <ArrowRight color="#195AFF" width={26} height={26} />
      </div>
    )
  }

  render() {
    const { classes } = this.props;
    if (this.props.howToMenu === 'Keyman Letter入稿ガイド') {
      return (
        <div className={classes.root}>
          <div className={classes.guide}>
            {this.renderHead('Keyman Letter入稿ガイド', '手紙の入稿形式や、Word上での編集で気をつけることなどをご確認いただけます。', 'guide1')}
            <div className={classes.body}>
              <div className={classes.section} id="guide1">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    入稿データの拡張子について
                  </div>
                </div>
                <div className={classes.detail}>
                  アップロード可能なデータ形式は<span className={classes.bold}>.docx</span>形式のみになります
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  注文時にWordファイルが原因のエラーが発生して注文ができない場合
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  Google docsなどのサービスから書き出したWordファイルはコンテンツコントロールなどKeyman Letterがサポートしない要素が含まれるため、
                  <span className={classes.bold}>そのままではアップロードできません</span>。
                  <span className={classes.bold}>コンテンツコントロールを手動で外してからアップロードしていただくか、Microsoft WordまたはMicrosoft 365を利用してWordファイルを作成してください</span>。
                  <a
                    href="https://www.microsoft.com/ja-jp/microsoft-365/free-office-online-for-the-web"
                    target="_blank"
                    rel="noreferrer noopener"
                    className={classes.link}
                    onClick={e => { e.stopPropagation(); }}
                  >
                   Microsoft 365
                  </a>
                  は無料で利用することができます。
                </div>
                <div className={classes.detail} style={{ marginTop: 15 }}>
                  また、入稿データはWordの差し込み印刷機能を利用しておりMicrosoft Wordの表示・挙動を正としてシステムを運用しておりますのでGoogle docsやPagesなどで書き出したWordファイルはMicrosoft Wordで開いて崩れていないかの確認及び修正をお願いいたします。
                </div>
              </div>
              {this.renderSectionContent('用紙サイズ・ページ数について', 'Wordの用紙サイズはA4に設定してください。\nA4一枚の表面のみの印刷とさせていただいておりますので、1ページに収まるようお願いいたします。', 'guide2')}
              <div className={classes.section} id="guide3">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    雛形について
                  </div>
                </div>
                <div className={classes.detail}>
                  内容物の作成はKeyman Letterが推奨する雛形をご利用ください。
                </div>
                <div className={classes.linkGroup}>
                  <div className={classes.templateLink} onClick={() => this.props.handleDownloadFile(false)}>
                    テンプレート「ご面会依頼の件」①
                  </div>
                  <div className={classes.templateLink} onClick={() => this.props.handleDownloadFile(true)}>
                    {"テンプレート「ご面会依頼の件」②"}
                  </div>
                </div>
              </div>
              {this.renderSectionContent('フォントについて', '環境依存の問題により、選択されたフォントによっては代替の明朝体フォントで印刷される場合がございます。また、フォントによってサイズが異なるため、1ページに収まるように調整する場合がございます。', 'guide4')}
              <div className={classes.section} id="guide5">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    可変テキストについて
                  </div>
                </div>
                <div className={classes.detail}>
                  {'可変テキストとは、宛先ごとに文言をカスタマイズできるテキストのことです。雛形にあるように、{company}、{name}、{year&month}という波括弧で囲まれた文言が、宛先の「組織名」と「名前」、「手紙の到着予定日（発送予定日の＋１日）の年月」に置換されて印刷されます。'}
                </div>
                <div className={classes.detail} style={{ marginTop: 15 }}>
                  {'手紙の文章中に可変テキストを入れることで、受け手に向けて手紙を出していることを強調することができ、アポ獲得率を高めることができます。現在使用できる可変テキストは{company}{name}{year&month}のみです。'}
                </div>
                <div className={classes.caution}>
                  {`※ 複数の宛先の注文の場合可変テキストの{company}と{name}は必ず文面に入れてください。入っていない場合は入力エラーになります。`}
                </div>
              </div>
              <div className={classes.section} id="guide6">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    入稿データについて
                  </div>
                </div>
                <div className={classes.detail}>
                  入稿データを作成する際、構成が崩れる可能性がございますので<span className={classes.bold}>ヘッダーやフッターのご使用はお控えください。</span>また、<span className={classes.bold}>同じ入稿データで複数の宛先に送りする場合、1通ずつの注文ではなく、宛先をまとめて選択した上ご注文頂くようお願い申し上げます。</span>まとめ方がわからない場合、サポートの方まで画面右下のチャットよりお問い合わせくださいませ。
                </div>
              </div>
              <div className={classes.section} id="guide7">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    トラッキングQRコードの設定手順について
                  </div>
                </div>
                <div className={classes.about}>
                  設定までの手順
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  まずは、QRコードの画像(ダミーでも構いません)を通常通りWordファイルに配置いただき、Keyman Letterの「手紙を送る」画面にてアップロードしていただきます。
                </div>
                <div className={classes.detail} style={{ marginTop: 15 }}>
                  同画面にQRコードのURLを入力する欄がありますので、こちらをご入力いただきます。
                </div>
                <div className={classes.detail} style={{ marginTop: 15 }}>
                  最後に、ご注文ボタンを押して完了となります。
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  リアクションの確認方法
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  送信された注文は、<span className={classes.bold}>印刷データ作成時にWord内のQRコードがトラッキング用のQRコードに挿し替え</span>られ、お宛名へと届けられます。このQRコードが読み込まれると、「タイムライン」画面にリアクションとしてステータスが追加されるようになります。タイムラインへは、手紙ダッシュボード画面にて該当のターゲットをクリックしてアクセス可能です。
                </div>
              </div>
              <div className={classes.section} id="guide8">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    添付物について
                  </div>
                </div>
                <div className={classes.detail} style={{ marginTop: 15 }}>
                  {'縦A4サイズ 2ページ以内に収まるようお願いいたします。\n2ページの場合は両面印刷となります。'}
                </div>
                <div className={classes.detail} style={{ marginTop: 15 }}>
                  {'添付物は印刷する際に3mmから5mmほど外側に余白が発生しますのでご了承くださいませ。'}
                </div>
                <div className={classes.detail} style={{ marginTop: 15 }}>
                  少々のサイズ差異は許容していますが、印刷したときに見切れたりしないようにあらかじめプログラムでサイズを制限させていただいております。
                </div>
                <div className={classes.caution}>
                  <span className={classes.bold}>A4サイズの規定値</span>：短辺: 8.27インチ・長辺: 11.68インチ
                </div>
                <div className={classes.about} style={{ marginTop: 25 }}>
                  サイズによるアップロードができないよくあるエラー
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  PowerPointでPDFを作成したケースがあります。PowerPointの設定上A4サイズはKeyman LetterのA4サイズの許容範囲外になる可能性があります。
                </div>
                <div className={classes.detail} style={{ marginTop: 15 }}>
                  その際はPowerPointのスライドのサイズ指定を「ユーザー設定」に変更し、<span className={classes.bold}>幅: 21㎝・高さ: 29.7㎝</span>で作成すると、アップロード可能になります。
                </div>
              </div>
            </div>
            <div className={classes.section} id="guide9">
              <div className={classes.pointLine}>
                <div className={classes.about}>
                  発送予定日、到着予定日について
                </div>
              </div>
              <div className={classes.detail}>
                午前中に注文した手紙は本日を含めて3営業日後、午後に注文した手紙は当日を含めて4営業日後目安に発送されます。到着予定日は発送予定日の1〜2営業日が目安です。
              </div>
              <div className={classes.detail} style={{ marginTop: 15 }}>
                内容物に日付を入れる場合は到着予定日を考慮した上で内容物を作成してください。
              </div>
            </div>
          </div>
          <div className={classes.guide}>
            <Typography variant="subheading" style={{ fontSize: 28, marginBottom: 55, letterSpacing: '0.48px', textIndent: '0.48px', lineHeight: '1.5em' }}>
              レターの書き方やQRコードの活用方法はこちら
            </Typography>
            {this.renderArticleLink('レター書き方Tips', '時候の挨拶、文面の書き方や効果的な構成など、レターの書き方に関する豆知識をまとめてご紹介します。', '/how-to/send-letter/tips')}
            <div style={{ marginTop: 30 }}>
              {this.renderArticleLink('QRコードの効果的な活用方法', '会社HPから日程調整URLまで、QRコードのリンク先の事例をご紹介します。QRコードの設定手順についても記載しています。', '/how-to/send-letter/qrcode')}
            </div>
          </div>
        </div>
      )
    } else if (this.props.howToMenu === 'レター書き方Tips') {
      return (
        <div className={classes.root}>
          <div className={classes.guide}>
            {this.renderHead('レター書き方Tips', '時候の挨拶、文面の書き方や効果的な構成など、レターの書き方に関する豆知識をまとめてご紹介します。')}
            <div className={classes.body}>
              <div className={classes.section} id="tips1">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    日付について
                  </div>
                </div>
                <div className={classes.detail}>
                  雛形を使用する場合、
                  <span className={classes.bold}>ご自身での日付の記載は必要ありません。</span>
                  {'雛形の可変テキスト{company}、{name}、\n{year&month}という波括弧で囲まれた文言が、宛先の「組織名」と「名前」、「手紙の到着予定日（発送予定日の＋１日）の年月」に置換されて印刷されます。'}
                </div>
                <div className={classes.detail} style={{ marginTop: 15 }}>
                  ご自身での記載をする場合は「〇〇年〇〇月吉日」のように記載すると丁寧です。
                </div>
              </div>
              {this.renderSectionContent('時候の挨拶', '時候の挨拶とは、季節や天候に応じた心情や季節感を現す言葉で、「頭語」の後に続く礼儀文です。「～の候」という古くからの漢語調の挨拶だけでなく、ほんの一手間かけても良いかもしれません。', 'tips2')}
              <div className={classes.section} id="tips3">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    文面の作り方
                  </div>
                </div>
                <div className={classes.about}>
                  手紙の冒頭に、簡潔でわかりやすい題名をつける
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  特に新規開拓営業において、初めて手紙を送付する際は、手紙の冒頭に<span className={classes.bold}>一目見てわかりやすい題名</span>をつけることを意識しましょう。一目見てわからない場合、目を通してくれないこともあります。冒頭に興味を引く題名をつけ、<span className={classes.bold}>最後まで手紙を読んでもらえるような工夫</span>をすることが大切です。
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  斜め読みでも伝わる文面を作る
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  斜め読みでも伝わる文面を作るには、<span className={classes.bold}>文字を太くしたり</span>、<span className={classes.underline}>下線を追加する</span>のが効果的です。重要な箇所はプレーンテキストではなく、強調してみてはいかがでしょうか。
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  文章の構成を意識して書く
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  最初に、手紙を送付した目的と自身が何者かを記載し、その後に自社が提供できる商品やサービスを具体的に説明しましょう。<span className={classes.bold}>導入実績や競合サービス等との比較</span>などを具体的に示すのも効果的です。
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  Why Now , Why You を明確にする
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  「なぜ今、なぜ連絡したのか」を明確にすると、納得感を持って手紙を読んでいただけるでしょう。レターを受け取ったキーマンに<span className={classes.bold}>自分に役立ちそうな情報だと思ってもらう</span>ことが重要です。
                </div>
              </div>
              <div className={classes.section} id="tips4">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    QRコードの追加
                  </div>
                </div>
                <div className={classes.detail}>
                  手紙の内容に興味を持ってくれたキーマンを逃さないよう、QRコードを設置して<span className={classes.bold}>次のアクションを促しましょう</span>。Keyman Letterでは、<span className={classes.bold}>QRコード読み込みをリアルタイムトラッキング</span>することができます。QRコードを活用し、読み込んだキーマンに次のアプローチをしましょう。
                </div>
                <div className={classes.detail} style={{ marginTop: 15 }}>
                  QRコードの効果的な活用例については以下のリンクからご確認ください。
                </div>
                <div style={{ marginTop: 25 }}>
                  {this.renderArticleLink('QRコードの効果的な活用方法', '会社HPから日程調整URLまで、QRコードのリンク先の事例をご紹介します。QRコードの設定手順についても記載しています。', '/how-to/send-letter/qrcode')}
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else if (this.props.howToMenu === 'QRコードの効果的な活用方法') {
      return (
        <div className={classes.root}>
          <div className={classes.guide}>
            {this.renderHead('QRコードの効果的な活用方法', '会社HPから日程調整URLまで、QRコードのリンク先の事例をご紹介します。QRコードの設定手順についても記載しています。')}
            <div className={classes.body}>
              <div className={classes.section} id="qrcode1">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    主なQRコードのリンク先
                  </div>
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  自社ホームページ・自社サービスページ
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  自社のHPや自社サービスページを設定するパターンです。<span className={classes.bold}>LPなどのURL</span>
                  {"を設定すると、CVを獲得することなどに繋がります。\n"}
                  また、<span className={classes.bold}>導入事例・実績ページのURL</span>
                  {"を設定すると、キーマンに導入した際のイメージを持ってもらう効果を狙えます。\n"}
                  他にも、<span className={classes.bold}>お問い合わせフォームのURL</span>を設定し、角度の高いキーマンをお問い合わせに誘導することもできます。
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  日程調整ツール
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  Dr.Works、YouCanBookMe、Spir、eeasy などの日程調整ツールのURLを設定すると、手紙を受け取ったキーマンとの商談などをすぐに取り付けることができます。
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  サービス紹介の動画
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  YouTube、Vimeo などの動画再生ページのURLを設定し、プロモーションビデオをキーマンにみてもらうことができます。
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  オンライン名刺
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  Sansan、Eight などのオンライン名刺のURLを設定するパターンです。
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  セミナーやウェビナーに関するページ
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  <span className={classes.bold}>お知らせページのURL</span>を設定するパターンや、<span className={classes.bold}>申し込みページのURL</span>を設定するパターンなどがあります。他にも、zoomなどを活用して<span className={classes.bold}>ウェビナー参加URL</span>を設定することもできます。
                </div>
              </div>
              <div className={classes.section} id="qrcode2">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    QRコードの近くにリンク先の情報について記載する
                  </div>
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  リンク先がお問い合わせフォームの場合は「お問い合わせはこちら」、新サービスのHPの場合は「サービスの概要はこちら」等の文言を配置することで、<span className={classes.bold}>手紙におけるUXの向上</span>を目指します。
                </div>
                <div className={classes.caution}>
                  <div className={classes.detail} style={{ fontWeight: 'bold' }}>
                    QRコードにアクセスしづらい要因の例
                  </div>
                  <div className={classes.detail} style={{ marginTop: 10 }}>
                    1. QRコードのリンク先がわからない ＞ アクセスの心理ハードルが高い状態
                  </div>
                  <div className={classes.detail} style={{ marginTop: 10 }}>
                    2. 想定したリンク先と実際のリンク先が異なる ＞ キーマンの満足度が低下
                  </div>
                </div>
                <div className={classes.about} style={{ marginTop: 30 }}>
                  リンク先のURLについての補足説明
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  QRコードを読み込むと、URLのドメインが［keymanletter.com］と表示されます。QRコードの近くにドメインについての注意書きを記載することで、手紙を受け取ったキーマンが疑問に思うことを防ぎます。
                </div>
                <div className={classes.caution}>
                  <div className={classes.detail} style={{ fontWeight: 'bold' }}>
                    注意書きの例
                  </div>
                  <div className={classes.detail} style={{ marginTop: 10 }}>
                    ※ドメインがkeymanletter.comとなっておりますが、Keyman Letterを利用した手紙のためこのようになっておりますのでご心配いりません
                  </div>
                </div>
              </div>
              {this.renderSectionContent('効果的なレターを書く', 'QRコードをより多く読み込んでもらうには、レターの書き方も重要になってきます。レターの書き方に関する豆知識は以下のリンクからご確認ください。', 'qrcode3')}
              <div style={{ marginTop: 25 }}>
                {this.renderArticleLink('レター書き方Tips', '時候の挨拶、文面の書き方や効果的な構成など、レターの書き方に関する豆知識をまとめてご紹介します。', '/how-to/send-letter/tips')}
              </div>
              <div className={classes.section} id="qrcode4">
                <div className={classes.pointLine}>
                  <div className={classes.about}>
                    トラッキングQRコードの設定手順について
                  </div>
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  設定までの手順
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  まずは、QRコードの画像(ダミーでも構いません)を通常通りWordファイルに配置いただき、Keyman Letterの「手紙を送る」画面にてアップロードしていただきます。
                </div>
                <div className={classes.detail} style={{ marginTop: 20 }}>
                  同画面にQRコードのURLを入力する欄がありますので、こちらをご入力いただきます。
                </div>
                <div className={classes.detail} style={{ marginTop: 20 }}>
                  最後に、ご注文ボタンを押して完了となります。
                </div>
                <div className={classes.about} style={{ marginTop: 20 }}>
                  リアクションの確認方法
                </div>
                <div className={classes.detail} style={{ marginTop: 10 }}>
                  送信された注文は、<span className={classes.bold}>印刷データ作成時にWord内のQRコードがトラッキング用のQRコードに挿し替え</span>られ、お宛名へと届けられます。このQRコードが読み込まれると、「タイムライン」画面にリアクションとしてステータスが追加されるようになります。タイムラインへは、手紙ダッシュボード画面にて該当のターゲットをクリックしてアクセス可能です。
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}

HowToLetterSend.propTypes = {
  classes: PropTypes.object.isRequired,
  goTo: PropTypes.func.isRequired,
  handleDownloadFile: PropTypes.func.isRequired,
  howToMenu: PropTypes.string.isRequired,
};

export default withStyles(styles)(HowToLetterSend);



// WEBPACK FOOTER //
// ./src/components/Faq/HowToLetterSend.jsx